export const [PENDING_APPROVALS_LOADED, APPROVAL_SUCCESS] =
    ['PENDING_APPROVALS_LOADED', 'APPROVAL_SUCCESS']